import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconSkipBack = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.80383 4.21871L6.04658 2.21593L4.23713 2L3.6709 6.67163C3.64168 6.91269 3.7114 7.15529 3.86436 7.3448C4.01732 7.53432 4.24067 7.65483 4.48413 7.67921L8.99908 8.13128L9.18206 6.33205L6.43459 6.05695C7.89526 4.72698 9.84114 3.91635 11.9763 3.91635C16.5031 3.91635 20.1775 7.56227 20.1775 12.054C20.1775 16.5457 16.5031 20.1916 11.9763 20.1916C8.76256 20.1916 5.9763 18.3541 4.63111 15.676L3 16.4827C4.64126 19.7502 8.04442 22 11.9763 22C17.5097 22 22 17.5444 22 12.054C22 6.56354 17.5097 2.10798 11.9763 2.10798C9.64831 2.10798 7.50518 2.89708 5.80383 4.21871Z",
		fill: "black"
	})
});
export default SvgIconSkipBack;
